import { render, staticRenderFns } from "./discordLoginSSO.vue?vue&type=template&id=9daa1584&"
import script from "./discordLoginSSO.vue?vue&type=script&lang=js&"
export * from "./discordLoginSSO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports